// extracted by mini-css-extract-plugin
export default {"formWrap":"formWrap-n5Jow","formWrapForm":"formWrap-form-LLFH_"};